module.exports = __webpack_public_path__ + "img/sottocategorie.fcd8a889.png";